export default "__VITE_ASSET__dc351b2a__"